export interface LevelDef {
  id: number;
  worldId: number;
  title: string;
  map: string;
  optimalMoves: number;
  difficulty: number;
}

// Microban levels by David W. Skinner
// Copyright: David W. Skinner
// Website: http://users.bentonrea.com/~sasquatch/sokoban/
// 155 puzzles, revised April 2000
// "A good set for beginners and children"
// Optimal move counts verified by BFS solver

export const LEVELS: LevelDef[] = [
  {
    id: 1,
    worldId: 1,
    title: "Microban #1",
    map: [
      "####",
      "# .#",
      "#  ###",
      "#*@  #",
      "#  $ #",
      "#  ###",
      "####",
    ].join("\n"),
    optimalMoves: 33,
    difficulty: 2,
  },
  {
    id: 2,
    worldId: 1,
    title: "Microban #2",
    map: [
      "######",
      "#    #",
      "# #@ #",
      "# $* #",
      "# .* #",
      "#    #",
      "######",
    ].join("\n"),
    optimalMoves: 16,
    difficulty: 1,
  },
  {
    id: 3,
    worldId: 1,
    title: "Microban #3",
    map: [
      "  ####",
      "###  ####",
      "#     $ #",
      "# #  #$ #",
      "# . .#@ #",
      "#########",
    ].join("\n"),
    optimalMoves: 41,
    difficulty: 3,
  },
  {
    id: 4,
    worldId: 1,
    title: "Microban #4",
    map: [
      "########",
      "#      #",
      "# .**$@#",
      "#      #",
      "#####  #",
      "    ####",
    ].join("\n"),
    optimalMoves: 23,
    difficulty: 1,
  },
  {
    id: 5,
    worldId: 1,
    title: "Microban #5",
    map: [
      " #######",
      " #     #",
      " # .$. #",
      "## $@$ #",
      "#  .$. #",
      "#      #",
      "########",
    ].join("\n"),
    optimalMoves: 25,
    difficulty: 1,
  },
  {
    id: 6,
    worldId: 1,
    title: "Microban #6",
    map: [
      "###### #####",
      "#    ###   #",
      "# $$     #@#",
      "# $ #...   #",
      "#   ########",
      "#####",
    ].join("\n"),
    optimalMoves: 107,
    difficulty: 6,
  },
  {
    id: 7,
    worldId: 1,
    title: "Microban #7",
    map: [
      "#######",
      "#     #",
      "# .$. #",
      "# $.$ #",
      "# .$. #",
      "# $.$ #",
      "#  @  #",
      "#######",
    ].join("\n"),
    optimalMoves: 150,
    difficulty: 7,
  },
  {
    id: 8,
    worldId: 1,
    title: "Microban #8",
    map: [
      "  ######",
      "  # ..@#",
      "  # $$ #",
      "  ## ###",
      "   # #",
      "   # #",
      "#### #",
      "#    ##",
      "# #   #",
      "#   # #",
      "###   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 97,
    difficulty: 5,
  },
  {
    id: 9,
    worldId: 1,
    title: "Microban #9",
    map: [
      "#####",
      "#.  ##",
      "#@$$ #",
      "##   #",
      " ##  #",
      "  ##.#",
      "   ###",
    ].join("\n"),
    optimalMoves: 30,
    difficulty: 2,
  },
  {
    id: 10,
    worldId: 1,
    title: "Microban #10",
    map: [
      "      #####",
      "      #.  #",
      "      #.# #",
      "#######.# #",
      "# @ $ $ $ #",
      "# # # # ###",
      "#       #",
      "#########",
    ].join("\n"),
    optimalMoves: 89,
    difficulty: 5,
  },
  {
    id: 11,
    worldId: 1,
    title: "Microban #11",
    map: [
      "  ######",
      "  #    #",
      "  # ##@##",
      "### # $ #",
      "# ..# $ #",
      "#       #",
      "#  ######",
      "####",
    ].join("\n"),
    optimalMoves: 78,
    difficulty: 4,
  },
  {
    id: 12,
    worldId: 1,
    title: "Microban #12",
    map: [
      "#####",
      "#   ##",
      "# $  #",
      "## $ ####",
      " ###@.  #",
      "  #  .# #",
      "  #     #",
      "  #######",
    ].join("\n"),
    optimalMoves: 49,
    difficulty: 3,
  },
  {
    id: 13,
    worldId: 1,
    title: "Microban #13",
    map: [
      "####",
      "#. ##",
      "#.@ #",
      "#. $#",
      "##$ ###",
      " # $  #",
      " #    #",
      " #  ###",
      " ####",
    ].join("\n"),
    optimalMoves: 52,
    difficulty: 3,
  },
  {
    id: 14,
    worldId: 1,
    title: "Microban #14",
    map: [
      "#######",
      "#     #",
      "# # # #",
      "#. $*@#",
      "#   ###",
      "#####",
    ].join("\n"),
    optimalMoves: 51,
    difficulty: 3,
  },
  {
    id: 15,
    worldId: 1,
    title: "Microban #15",
    map: [
      "     ###",
      "######@##",
      "#    .* #",
      "#   #   #",
      "#####$# #",
      "    #   #",
      "    #####",
    ].join("\n"),
    optimalMoves: 37,
    difficulty: 2,
  },
  {
    id: 16,
    worldId: 1,
    title: "Microban #16",
    map: [
      " ####",
      " #  ####",
      " #     ##",
      "## ##   #",
      "#. .# @$##",
      "#   # $$ #",
      "#  .#    #",
      "##########",
    ].join("\n"),
    optimalMoves: 100,
    difficulty: 5,
  },
  {
    id: 17,
    worldId: 1,
    title: "Microban #17",
    map: [
      "#####",
      "# @ #",
      "#...#",
      "#$$$##",
      "#    #",
      "#    #",
      "######",
    ].join("\n"),
    optimalMoves: 25,
    difficulty: 1,
  },
  {
    id: 18,
    worldId: 1,
    title: "Microban #18",
    map: [
      "#######",
      "#     #",
      "#. .  #",
      "# ## ##",
      "#  $ #",
      "###$ #",
      "  #@ #",
      "  #  #",
      "  ####",
    ].join("\n"),
    optimalMoves: 71,
    difficulty: 4,
  },
  {
    id: 19,
    worldId: 1,
    title: "Microban #19",
    map: [
      "########",
      "#   .. #",
      "#  @$$ #",
      "##### ##",
      "   #  #",
      "   #  #",
      "   #  #",
      "   ####",
    ].join("\n"),
    optimalMoves: 41,
    difficulty: 3,
  },
  {
    id: 20,
    worldId: 1,
    title: "Microban #20",
    map: [
      "#######",
      "#     ###",
      "#  @$$..#",
      "#### ## #",
      "  #     #",
      "  #  ####",
      "  #  #",
      "  ####",
    ].join("\n"),
    optimalMoves: 50,
    difficulty: 3,
  },
  {
    id: 21,
    worldId: 2,
    title: "Microban #21",
    map: [
      "####",
      "#  ####",
      "# . . #",
      "# $$#@#",
      "##    #",
      " ######",
    ].join("\n"),
    optimalMoves: 17,
    difficulty: 1,
  },
  {
    id: 22,
    worldId: 2,
    title: "Microban #22",
    map: [
      "#####",
      "#   ###",
      "#. .  #",
      "#   # #",
      "## #  #",
      " #@$$ #",
      " #    #",
      " #  ###",
      " ####",
    ].join("\n"),
    optimalMoves: 47,
    difficulty: 3,
  },
  {
    id: 23,
    worldId: 2,
    title: "Microban #23",
    map: [
      "#######",
      "#  *  #",
      "#     #",
      "## # ##",
      " #$@.#",
      " #   #",
      " #####",
    ].join("\n"),
    optimalMoves: 56,
    difficulty: 3,
  },
  {
    id: 24,
    worldId: 2,
    title: "Microban #24",
    map: [
      "# #####",
      "  #   #",
      "###$$@#",
      "#   ###",
      "#     #",
      "# . . #",
      "#######",
    ].join("\n"),
    optimalMoves: 35,
    difficulty: 2,
  },
  {
    id: 25,
    worldId: 2,
    title: "Microban #25",
    map: [
      " ####",
      " #  ###",
      " # $$ #",
      "##... #",
      "#  @$ #",
      "#   ###",
      "#####",
    ].join("\n"),
    optimalMoves: 29,
    difficulty: 2,
  },
  {
    id: 26,
    worldId: 2,
    title: "Microban #26",
    map: [
      " #####",
      " # @ #",
      " #   #",
      "###$ #",
      "# ...#",
      "# $$ #",
      "###  #",
      "  ####",
    ].join("\n"),
    optimalMoves: 41,
    difficulty: 3,
  },
  {
    id: 27,
    worldId: 2,
    title: "Microban #27",
    map: [
      "######",
      "#   .#",
      "# ## ##",
      "#  $$@#",
      "# #   #",
      "#.  ###",
      "#####",
    ].join("\n"),
    optimalMoves: 50,
    difficulty: 3,
  },
  {
    id: 28,
    worldId: 2,
    title: "Microban #28",
    map: [
      "#####",
      "#   #",
      "# @ #",
      "# $$###",
      "##. . #",
      " #    #",
      " ######",
    ].join("\n"),
    optimalMoves: 33,
    difficulty: 2,
  },
  {
    id: 29,
    worldId: 2,
    title: "Microban #29",
    map: [
      "     #####",
      "     #   ##",
      "     #    #",
      " ######   #",
      "##     #. #",
      "# $ $ @  ##",
      "# ######.#",
      "#        #",
      "##########",
    ].join("\n"),
    optimalMoves: 104,
    difficulty: 6,
  },
  {
    id: 30,
    worldId: 2,
    title: "Microban #30",
    map: [
      "####",
      "#  ###",
      "# $$ #",
      "#... #",
      "# @$ #",
      "#   ##",
      "#####",
    ].join("\n"),
    optimalMoves: 21,
    difficulty: 1,
  },
  {
    id: 31,
    worldId: 2,
    title: "Microban #31",
    map: [
      "  ####",
      " ##  #",
      "##@$.##",
      "# $$  #",
      "# . . #",
      "###   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 17,
    difficulty: 1,
  },
  {
    id: 32,
    worldId: 2,
    title: "Microban #32",
    map: [
      " ####",
      "##  ###",
      "#     #",
      "#.**$@#",
      "#   ###",
      "##  #",
      " ####",
    ].join("\n"),
    optimalMoves: 35,
    difficulty: 2,
  },
  {
    id: 33,
    worldId: 2,
    title: "Microban #33",
    map: [
      "#######",
      "#. #  #",
      "#  $  #",
      "#. $#@#",
      "#  $  #",
      "#. #  #",
      "#######",
    ].join("\n"),
    optimalMoves: 41,
    difficulty: 3,
  },
  {
    id: 34,
    worldId: 2,
    title: "Microban #34",
    map: [
      "  ####",
      "###  ####",
      "#       #",
      "#@$***. #",
      "#       #",
      "#########",
    ].join("\n"),
    optimalMoves: 30,
    difficulty: 2,
  },
  {
    id: 35,
    worldId: 2,
    title: "Microban #35",
    map: [
      "  ####",
      " ##  #",
      " #. $#",
      " #.$ #",
      " #.$ #",
      " #.$ #",
      " #. $##",
      " #   @#",
      " ##   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 77,
    difficulty: 4,
  },
  {
    id: 36,
    worldId: 2,
    title: "Microban #36",
    map: [
      "####",
      "#  ############",
      "# $ $ $ $ $ @ #",
      "# .....       #",
      "###############",
    ].join("\n"),
    optimalMoves: 90,
    difficulty: 5,
  },
  {
    id: 37,
    worldId: 2,
    title: "Microban #37",
    map: [
      "      ###",
      "##### #.#",
      "#   ###.#",
      "#   $ #.#",
      "# $  $  #",
      "#####@# #",
      "    #   #",
      "    #####",
    ].join("\n"),
    optimalMoves: 71,
    difficulty: 4,
  },
  {
    id: 38,
    worldId: 2,
    title: "Microban #38",
    map: [
      "##########",
      "#        #",
      "# ##.### #",
      "# # $$ . #",
      "# . @$## #",
      "#####    #",
      "    ######",
    ].join("\n"),
    optimalMoves: 37,
    difficulty: 2,
  },
  {
    id: 39,
    worldId: 2,
    title: "Microban #39",
    map: [
      "#####",
      "#   ####",
      "# # # .#",
      "#    $ ###",
      "### #$.  #",
      "#   #@   #",
      "# # ######",
      "#   #",
      "#####",
    ].join("\n"),
    optimalMoves: 85,
    difficulty: 5,
  },
  {
    id: 40,
    worldId: 2,
    title: "Microban #40",
    map: [
      " #####",
      " #   #",
      "##   ##",
      "# $$$ #",
      "# .+. #",
      "#######",
    ].join("\n"),
    optimalMoves: 20,
    difficulty: 1,
  },
  {
    id: 41,
    worldId: 2,
    title: "Microban #41",
    map: [
      "#######",
      "#     #",
      "#@$$$ ##",
      "#  #...#",
      "##    ##",
      " ######",
    ].join("\n"),
    optimalMoves: 50,
    difficulty: 3,
  },
  {
    id: 42,
    worldId: 2,
    title: "Microban #42",
    map: [
      "   ####",
      "   #  #",
      "   #@ #",
      "####$.#",
      "#   $.#",
      "# # $.#",
      "#    ##",
      "######",
    ].join("\n"),
    optimalMoves: 47,
    difficulty: 3,
  },
  {
    id: 43,
    worldId: 2,
    title: "Microban #43",
    map: [
      "     ####",
      "     # @#",
      "     #  #",
      "###### .#",
      "#   $  .#",
      "#  $$# .#",
      "#    ####",
      "###  #",
      "  ####",
    ].join("\n"),
    optimalMoves: 61,
    difficulty: 4,
  },
  {
    id: 44,
    worldId: 2,
    title: "Microban #44",
    map: [
      "#####",
      "#@$.#",
      "#####",
    ].join("\n"),
    optimalMoves: 1,
    difficulty: 1,
  },
  {
    id: 45,
    worldId: 2,
    title: "Microban #45",
    map: [
      "######",
      "#... #",
      "#  $ #",
      "# #$##",
      "#  $ #",
      "#  @ #",
      "######",
    ].join("\n"),
    optimalMoves: 45,
    difficulty: 3,
  },
  {
    id: 46,
    worldId: 2,
    title: "Microban #46",
    map: [
      " ######",
      "##    #",
      "#  ## #",
      "# # $ #",
      "#  * .#",
      "## #@##",
      " #   #",
      " #####",
    ].join("\n"),
    optimalMoves: 47,
    difficulty: 3,
  },
  {
    id: 47,
    worldId: 2,
    title: "Microban #47",
    map: [
      "  #######",
      "###     #",
      "# $ $   #",
      "# ### #####",
      "# @ . .   #",
      "#   ###   #",
      "##### #####",
    ].join("\n"),
    optimalMoves: 83,
    difficulty: 5,
  },
  {
    id: 48,
    worldId: 2,
    title: "Microban #48",
    map: [
      "######",
      "#  @ #",
      "#  # ##",
      "# .#  ##",
      "# .$$$ #",
      "# .#   #",
      "####   #",
      "   #####",
    ].join("\n"),
    optimalMoves: 64,
    difficulty: 4,
  },
  {
    id: 49,
    worldId: 2,
    title: "Microban #49",
    map: [
      "######",
      "# @  #",
      "# $# #",
      "# $  #",
      "# $ ##",
      "### ####",
      " #  #  #",
      " #...  #",
      " #     #",
      " #######",
    ].join("\n"),
    optimalMoves: 82,
    difficulty: 5,
  },
  {
    id: 50,
    worldId: 2,
    title: "Microban #50",
    map: [
      "  ####",
      "###  #####",
      "#  $  @..#",
      "# $    # #",
      "### #### #",
      "  #      #",
      "  ########",
    ].join("\n"),
    optimalMoves: 76,
    difficulty: 4,
  },
  {
    id: 51,
    worldId: 3,
    title: "Microban #51",
    map: [
      "####",
      "#  ###",
      "#    ###",
      "#  $*@ #",
      "### .# #",
      "  #    #",
      "  ######",
    ].join("\n"),
    optimalMoves: 34,
    difficulty: 2,
  },
  {
    id: 52,
    worldId: 3,
    title: "Microban #52",
    map: [
      "  ####",
      "### @#",
      "#  $ #",
      "#  *.#",
      "#  *.#",
      "#  $ #",
      "###  #",
      "  ####",
    ].join("\n"),
    optimalMoves: 26,
    difficulty: 2,
  },
  {
    id: 53,
    worldId: 3,
    title: "Microban #53",
    map: [
      " #####",
      "##. .##",
      "# * * #",
      "#  #  #",
      "# $ $ #",
      "## @ ##",
      " #####",
    ].join("\n"),
    optimalMoves: 37,
    difficulty: 2,
  },
  {
    id: 54,
    worldId: 3,
    title: "Microban #54",
    map: [
      "      ######",
      "      #    #",
      "  ##### .  #",
      "###  ###.  #",
      "# $  $  . ##",
      "# @$$ # . #",
      "##    #####",
      " ######",
    ].join("\n"),
    optimalMoves: 82,
    difficulty: 5,
  },
  {
    id: 55,
    worldId: 3,
    title: "Microban #55",
    map: [
      "########",
      "# @ #  #",
      "#      #",
      "#####$ #",
      "    #  ###",
      " ## #$ ..#",
      " ## #  ###",
      "    ####",
    ].join("\n"),
    optimalMoves: 64,
    difficulty: 4,
  },
  {
    id: 56,
    worldId: 3,
    title: "Microban #56",
    map: [
      "#####",
      "#   ###",
      "#  $  #",
      "##* . #",
      " #   @#",
      " ######",
    ].join("\n"),
    optimalMoves: 23,
    difficulty: 1,
  },
  {
    id: 57,
    worldId: 3,
    title: "Microban #57",
    map: [
      "  ####",
      "  #  #",
      "  #@ #",
      "  #  #",
      "### ####",
      "#    * #",
      "#  $   #",
      "#####. #",
      "    ####",
    ].join("\n"),
    optimalMoves: 60,
    difficulty: 3,
  },
  {
    id: 58,
    worldId: 3,
    title: "Microban #58",
    map: [
      "####",
      "#  ####",
      "#.*$  #",
      "# .$# #",
      "## @  #",
      " #   ##",
      " #####",
    ].join("\n"),
    optimalMoves: 44,
    difficulty: 3,
  },
  {
    id: 59,
    worldId: 3,
    title: "Microban #59",
    map: [
      "############",
      "#          #",
      "# ####### @##",
      "# #         #",
      "# #  $   #  #",
      "# $$ #####  #",
      "###  # # ...#",
      "  #### #    #",
      "       ######",
    ].join("\n"),
    optimalMoves: 178,
    difficulty: 8,
  },
  {
    id: 60,
    worldId: 3,
    title: "Microban #60",
    map: [
      " #########",
      " #       #",
      "##@##### #",
      "#  #   # #",
      "#  #   $.#",
      "#  ##$##.#",
      "##$##  #.#",
      "#   $  #.#",
      "#   #  ###",
      "########",
    ].join("\n"),
    optimalMoves: 169,
    difficulty: 8,
  },
  {
    id: 61,
    worldId: 3,
    title: "Microban #61",
    map: [
      "########",
      "#      #",
      "# #### #",
      "# #...@#",
      "# ###$###",
      "# #     #",
      "#  $$ $ #",
      "####   ##",
      "   #.###",
      "   ###",
    ].join("\n"),
    optimalMoves: 100,
    difficulty: 5,
  },
  {
    id: 62,
    worldId: 3,
    title: "Microban #62",
    map: [
      "   ##########",
      "####    ##  #",
      "#  $$$....$@#",
      "#      ###  #",
      "#   #### ####",
      "#####",
    ].join("\n"),
    optimalMoves: 64,
    difficulty: 4,
  },
  {
    id: 63,
    worldId: 3,
    title: "Microban #63",
    map: [
      "#####   ####",
      "#   ##### .#",
      "#       $  ########",
      "###  #### .$    @ #",
      "  #  #  #  ####   #",
      "  ####  ####  #####",
    ].join("\n"),
    optimalMoves: 101,
    difficulty: 6,
  },
  {
    id: 64,
    worldId: 3,
    title: "Microban #64",
    map: [
      " ######",
      "##    #",
      "#   $ #",
      "#  $$ #",
      "### .#####",
      "  ##.# @ #",
      "   #.  $ #",
      "   #. ####",
      "   ####",
    ].join("\n"),
    optimalMoves: 95,
    difficulty: 5,
  },
  {
    id: 65,
    worldId: 3,
    title: "Microban #65",
    map: [
      "  ######",
      "  #    #",
      "  #  $ #",
      " ####$ #",
      "## $ $ #",
      "#....# ##",
      "#     @ #",
      "##  #   #",
      " ########",
    ].join("\n"),
    optimalMoves: 138,
    difficulty: 7,
  },
  {
    id: 66,
    worldId: 3,
    title: "Microban #66",
    map: [
      "   ###",
      "   #@#",
      " ###$###",
      "##  .  ##",
      "#  # #  #",
      "# #   # #",
      "# #   # #",
      "# #   # #",
      "#  # #  #",
      "## $ $ ##",
      " ##. .##",
      "  #   #",
      "  #   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 69,
    difficulty: 4,
  },
  {
    id: 67,
    worldId: 3,
    title: "Microban #67",
    map: [
      "#####",
      "#   ##",
      "# #  #",
      "#@$*.##",
      "##  . #",
      " # $# #",
      " ##   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 37,
    difficulty: 2,
  },
  {
    id: 68,
    worldId: 3,
    title: "Microban #68",
    map: [
      " ####",
      " #  ######",
      "##    $  #",
      "# .# $   #",
      "# .#$#####",
      "# .@ #",
      "######",
    ].join("\n"),
    optimalMoves: 98,
    difficulty: 5,
  },
  {
    id: 69,
    worldId: 3,
    title: "Microban #69",
    map: [
      "####  ####",
      "#  ####  #",
      "#  #  #  #",
      "#  #    $##",
      "#  . .#$  #",
      "#@ ## # $ #",
      "#   . #   #",
      "###########",
    ].join("\n"),
    optimalMoves: 125,
    difficulty: 7,
  },
  {
    id: 70,
    worldId: 3,
    title: "Microban #70",
    map: [
      "#####",
      "# @ ####",
      "#      #",
      "# $ $$ #",
      "##$##  #",
      "#   ####",
      "# ..  #",
      "##..  #",
      " ###  #",
      "   ####",
    ].join("\n"),
    optimalMoves: 78,
    difficulty: 4,
  },
  {
    id: 71,
    worldId: 3,
    title: "Microban #71",
    map: [
      "###########",
      "#     #   ###",
      "# $@$ # .  .#",
      "# ## ### ## #",
      "# #       # #",
      "# #   #   # #",
      "# ######### #",
      "#           #",
      "#############",
    ].join("\n"),
    optimalMoves: 120,
    difficulty: 6,
  },
  {
    id: 72,
    worldId: 3,
    title: "Microban #72",
    map: [
      "  ####",
      " ##  #####",
      " #  $  @ #",
      " #  $#   #",
      "#### #####",
      "#  #   #",
      "#    $ #",
      "# ..#  #",
      "#  .####",
      "#  ##",
      "####",
    ].join("\n"),
    optimalMoves: 105,
    difficulty: 6,
  },
  {
    id: 73,
    worldId: 3,
    title: "Microban #73",
    map: [
      "####",
      "#  #####",
      "# $$ $ #",
      "#      #",
      "## ## ##",
      "#...#@#",
      "# ### ##",
      "#      #",
      "#  #   #",
      "########",
    ].join("\n"),
    optimalMoves: 102,
    difficulty: 6,
  },
  {
    id: 74,
    worldId: 3,
    title: "Microban #74",
    map: [
      " ####",
      " #  #######",
      " #$ @#   .#",
      "## #$$   .#",
      "#  $  ##..#",
      "#   # #####",
      "###   #",
      "  #####",
    ].join("\n"),
    optimalMoves: 117,
    difficulty: 6,
  },
  {
    id: 75,
    worldId: 3,
    title: "Microban #75",
    map: [
      " #######",
      "## ....##",
      "#   ######",
      "#   $ $ @#",
      "###  $ $ #",
      "  ###    #",
      "    ######",
    ].join("\n"),
    optimalMoves: 92,
    difficulty: 5,
  },
  {
    id: 76,
    worldId: 3,
    title: "Microban #76",
    map: [
      " #####",
      "##   #",
      "#    #####",
      "#  #.#   #",
      "#@ #.# $ #",
      "#  #.#  ##",
      "#    #  #",
      "##  ##$$#",
      " ##     #",
      "  #  ####",
      "  ####",
    ].join("\n"),
    optimalMoves: 181,
    difficulty: 9,
  },
  {
    id: 77,
    worldId: 3,
    title: "Microban #77",
    map: [
      "##########",
      "# @ .... #",
      "#   ####$##",
      "## #  $ $ #",
      " # $      #",
      " #   ######",
      " #####",
    ].join("\n"),
    optimalMoves: 189,
    difficulty: 9,
  },
  {
    id: 78,
    worldId: 3,
    title: "Microban #78",
    map: [
      " #######",
      "##     ##",
      "#  $ $  #",
      "# $ $ $ #",
      "## ### ####",
      " #@  .....#",
      " ##     ###",
      "  #######",
    ].join("\n"),
    optimalMoves: 200,
    difficulty: 9,
  },
  {
    id: 79,
    worldId: 3,
    title: "Microban #79",
    map: [
      " #########",
      " #    #  #",
      "## $#$#  #",
      "#  .$.@  #",
      "#  .#    #",
      "##########",
    ].join("\n"),
    optimalMoves: 48,
    difficulty: 3,
  },
  {
    id: 80,
    worldId: 3,
    title: "Microban #80",
    map: [
      "####",
      "#  #######",
      "#  . ## .#",
      "# $#    .#",
      "## ## # .#",
      " #    #  #",
      " #### #  #",
      "  # @$ ###",
      "  # $$ #",
      "  #    #",
      "  ######",
    ].join("\n"),
    optimalMoves: 131,
    difficulty: 7,
  },
  {
    id: 81,
    worldId: 3,
    title: "Microban #81",
    map: [
      " #####",
      " #   #",
      " # . #",
      "## * #",
      "#  *##",
      "#  @##",
      "## $ #",
      " #   #",
      " #####",
    ].join("\n"),
    optimalMoves: 46,
    difficulty: 3,
  },
  {
    id: 82,
    worldId: 3,
    title: "Microban #82",
    map: [
      "#####",
      "#   ###",
      "# .   ##",
      "##*#$  #",
      "# .# $ #",
      "# @## ##",
      "#     #",
      "#######",
    ].join("\n"),
    optimalMoves: 52,
    difficulty: 3,
  },
  {
    id: 83,
    worldId: 3,
    title: "Microban #83",
    map: [
      "######",
      "#    ##",
      "# $ $ ##",
      "## $$  #",
      " # #   #",
      " # ## ##",
      " #  . .#",
      " # @. .#",
      " #  ####",
      " ####",
    ].join("\n"),
    optimalMoves: 164,
    difficulty: 8,
  },
  {
    id: 84,
    worldId: 3,
    title: "Microban #84",
    map: [
      "########",
      "#  ... #",
      "#  ### ##",
      "#  # $  #",
      "## #@$  #",
      " # # $  #",
      " # ### #####",
      " #         #",
      " #   ###   #",
      " ##### #####",
    ].join("\n"),
    optimalMoves: 201,
    difficulty: 10,
  },
  {
    id: 85,
    worldId: 3,
    title: "Microban #85",
    map: [
      "       ####",
      " #######  #",
      " # $      #",
      " #   $ $  #",
      " # ########",
      "## # .  #",
      "#  # #  #",
      "#  @ . ##",
      "## # # #",
      " #   . #",
      " #######",
    ].join("\n"),
    optimalMoves: 155,
    difficulty: 8,
  },
  {
    id: 86,
    worldId: 3,
    title: "Microban #86",
    map: [
      "    ####",
      "  ###  ##",
      " ## $   #",
      "## $  # #",
      "# @#$$  #",
      "# ..  ###",
      "# ..###",
      "#####",
    ].join("\n"),
    optimalMoves: 105,
    difficulty: 6,
  },
  {
    id: 87,
    worldId: 3,
    title: "Microban #87",
    map: [
      "     ####",
      "######  #",
      "#       #",
      "#  ... .#",
      "##$######",
      "# $  #",
      "#   $###",
      "##  $  #",
      " ## @  #",
      "  ######",
    ].join("\n"),
    optimalMoves: 149,
    difficulty: 7,
  },
  {
    id: 88,
    worldId: 3,
    title: "Microban #88",
    map: [
      "     ####",
      " # ###  #",
      " # #    #",
      " # #  # #",
      " # #$ #.#",
      " # #  # # #",
      " # #$ #.# #",
      "   #  # # #",
      "####$ #.# #",
      "# @     # #",
      "#   #  ## #",
      "########",
    ].join("\n"),
    optimalMoves: 195,
    difficulty: 9,
  },
  {
    id: 89,
    worldId: 3,
    title: "Microban #89",
    map: [
      "##########",
      "#   ##   #",
      "# $  $@# #",
      "#### # $ #",
      "   #.#  ##",
      " # #.# $#",
      " # #.   #",
      " # #.   #",
      "   ######",
    ].join("\n"),
    optimalMoves: 146,
    difficulty: 7,
  },
  {
    id: 90,
    worldId: 3,
    title: "Microban #90",
    map: [
      " ########",
      " #  @   #",
      " # $  $ #",
      "### ## ###",
      "#  $..$  #",
      "#   ..   #",
      "##########",
    ].join("\n"),
    optimalMoves: 64,
    difficulty: 4,
  },
  {
    id: 91,
    worldId: 3,
    title: "Microban #91",
    map: [
      "###########",
      "#    .##  #",
      "# $$@..$$ #",
      "#   ##.   #",
      "###########",
    ].join("\n"),
    optimalMoves: 45,
    difficulty: 3,
  },
  {
    id: 92,
    worldId: 3,
    title: "Microban #92",
    map: [
      "  ####",
      "  #  #    #####",
      "  #  #    #   #",
      "  #  ######.# #",
      "####  $    .  #",
      "#   $$# ###.# #",
      "#   #   # #   #",
      "######### #@ ##",
      "          #  #",
      "          ####",
    ].join("\n"),
    optimalMoves: 126,
    difficulty: 7,
  },
  {
    id: 93,
    worldId: 3,
    title: "Microban #93",
    map: [
      " #########",
      "##   #   ##",
      "#    #    #",
      "#  $ # $  #",
      "#   *.*   #",
      "####.@.####",
      "#   *.*   #",
      "#  $ # $  #",
      "#    #    #",
      "##   #   ##",
      " #########",
    ].join("\n"),
    optimalMoves: 250,
    difficulty: 10,
  },
  {
    id: 94,
    worldId: 3,
    title: "Microban #94",
    map: [
      "#########",
      "# @ #   #",
      "# $ $   #",
      "##$### ##",
      "#  ...  #",
      "#   #   #",
      "######  #",
      "     ####",
    ].join("\n"),
    optimalMoves: 83,
    difficulty: 5,
  },
  {
    id: 95,
    worldId: 3,
    title: "Microban #95",
    map: [
      "########",
      "#@     #",
      "# .$$. #",
      "# $..$ #",
      "# $..$ #",
      "# .$$. #",
      "#      #",
      "########",
    ].join("\n"),
    optimalMoves: 200,
    difficulty: 9,
  },
  {
    id: 96,
    worldId: 3,
    title: "Microban #96",
    map: [
      "  ######",
      "  #    #",
      "  #    #",
      "#####  #",
      "#   #.#####",
      "#   $@$   #",
      "#####.#   #",
      "   ## ## ##",
      "   #   $.#",
      "   #   ###",
      "   #####",
    ].join("\n"),
    optimalMoves: 92,
    difficulty: 5,
  },
  {
    id: 97,
    worldId: 3,
    title: "Microban #97",
    map: [
      "   ####",
      "   #  ########",
      "#### $ $.....#",
      "#   $   ######",
      "#@### ###",
      "#  $  #",
      "# $ # #",
      "## #  #",
      " #    #",
      " ######",
    ].join("\n"),
    optimalMoves: 164,
    difficulty: 8,
  },
  {
    id: 98,
    worldId: 3,
    title: "Microban #98",
    map: [
      "#####",
      "#   ## ####",
      "#  $ ### .#",
      "# $   $  .#",
      "## $#####.# ####",
      "# $  # # .###  #",
      "#    # # .#  @ #",
      "###  # #       #",
      "  #### ##     ##",
      "        #######",
    ].join("\n"),
    optimalMoves: 180,
    difficulty: 8,
  },
  {
    id: 99,
    worldId: 3,
    title: "Microban #99",
    map: [
      "               #####",
      "               #   #",
      "#######  ####### # #",
      "#     #  #  #      #",
      "#  @  ####  #     ####",
      "#  #    ....## ####  #",
      "#    ##### ## $$ $ $ #",
      "######   #           #",
      "         #  ##########",
      "         ####",
    ].join("\n"),
    optimalMoves: 160,
    difficulty: 8,
  },
  {
    id: 100,
    worldId: 3,
    title: "Microban #100",
    map: [
      "#######",
      "# @#  #",
      "#.$   #",
      "#. # $##",
      "#.$#   #",
      "#. # $ #",
      "#  #   #",
      "########",
    ].join("\n"),
    optimalMoves: 155,
    difficulty: 8,
  },
];
